<template>
  <div class="not-found">
    <h1>{{ $t('Subscribe') }}</h1>

    <p>
      {{ message }}
    </p>

    <div v-if="isChecking" class="loader">
      {{ $t('Please wait...') }}
    </div>

    <router-link
      v-if="!isChecking"
      to="/"
      class="cmn--btn"
    >
      <span>{{ $t('Go Back Home') }}</span>
    </router-link>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useAuthStore } from "@/store/auth";

export default {
  name: "SubscribeView",

  data() {
    return {
      isChecking: true,
      message: this.$t(
        "Please wait, we are performing some required actions to let you in..."
      ),

      // Check every 10 seconds
      retryInterval: 10000,

      // Maximum number of attempts
      maxAttempts: 12,

      attempts: 0,

      retryTimer: null,
    };
  },

  methods: {
    ...mapActions(useAuthStore, ["subscribe"]),

    async checkSubscription(phone) {
      const authStore = useAuthStore();

      this.attempts++;

      console.log(
        `[Subscribe] Attempt ${this.attempts}/${this.maxAttempts}`
      );

      try {
        const result = await this.subscribe(phone);

        console.log("[Subscribe] Result:", result);
        console.log("[Subscribe] isLoggedIn:", authStore.isLoggedIn);
        console.log("[Subscribe] token:", authStore.token);

        /*
         * IMPORTANT:
         *
         * We consider subscription successful only when
         * the auth store confirms that the user is logged in
         * and has a token.
         */
        if (authStore.isLoggedIn && authStore.token) {
          console.log("[Subscribe] Subscription successful");

          this.isChecking = false;

          this.message = this.$t(
            "Subscription completed successfully. Redirecting..."
          );

          this.redirectUser();

          return true;
        }

        console.log(
          "[Subscribe] Subscription not ready yet."
        );

        return false;

      } catch (error) {
        console.error(
          "[Subscribe] Error:",
          error
        );

        return false;
      }
    },

    async startSubscriptionCheck(phone) {
      /*
       * First attempt immediately
       */
      const success = await this.checkSubscription(phone);

      if (success) {
        return;
      }

      /*
       * If subscription is not ready, retry every 10 seconds
       */
      this.scheduleRetry(phone);
    },

    scheduleRetry(phone) {
      /*
       * Stop if maximum attempts reached
       */
      if (this.attempts >= this.maxAttempts) {
        console.error(
          "[Subscribe] Maximum retry attempts reached."
        );

        this.isChecking = false;

        this.message = this.$t(
          "We could not complete the subscription at this time. Please try again later."
        );

        return;
      }

      console.log(
        `[Subscribe] Next check in ${
          this.retryInterval / 1000
        } seconds`
      );

      this.retryTimer = setTimeout(async () => {
        const success = await this.checkSubscription(phone);

        if (!success) {
          this.scheduleRetry(phone);
        }
      }, this.retryInterval);
    },

    redirectUser() {
      const redirectUrl = localStorage.getItem("redirectUrl");

      console.log(
        "[Subscribe] Redirect URL:",
        redirectUrl
      );

      if (redirectUrl) {
        localStorage.removeItem("redirectUrl");
        this.$router.push(redirectUrl);
      } else {
        this.$router.push("/");
      }
    },

    stopRetry() {
      if (this.retryTimer) {
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
      }
    },
  },

  async created() {
    const urlParams = new URLSearchParams(
      window.location.search
    );

    const phone = urlParams.get("CGMSISDN");

    console.log(
      "[Subscribe] Phone number from URL:",
      phone
    );

    if (!phone) {
      this.$router.push("/");
      return;
    }

    await this.startSubscriptionCheck(phone);
  },

  beforeUnmount() {
    this.stopRetry();
  },
};
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 10vh;
  height: 50vh;
}

.not-found h1 {
  font-size: 6rem;
  color: #ff4040;
}

.not-found p {
  font-size: 1.5rem;
  margin: 1rem 0;
}

.loader {
  margin-top: 20px;
  font-size: 1rem;
  opacity: 0.7;
}
</style>